import { useState } from "react";
import moment from "moment";

import Icon from "./Icon";
import LiveRate from "./LiveRate";
import ProfitLoss from "./ProfitLoss";
import TimeTick from "./Time";
import Trade from "../Trade/Trade";

import { Dialog } from "primereact/dialog";

export default function StandingCard({ item, index, id, userType, total }) {
  const [show, setShow] = useState(false);

  /** 🔹 Exchange Name */
  const exchangeName = (() => {
    switch (item.type) {
      case "nse":
        return "NSE";
      case "mcx":
        return "MCX";
      case "fo":
        return "OPTIONS";
      case "nse_cash":
        return "NSE-EQUITY";
      case "comex_future":
        return "COMEX";
      case "crypto_future":
        return "CRYPTO";
      case "forex_future":
        return "FOREX";
      case "us_stock":
        return "US-STOCK";
      case "sgx":
        return "SGX";
      case "index":
        return "OTHERS";
      default:
        return "--";
    }
  })();

  /** 🔹 Expiry Label */
  const expiryLabel =
    item.type === "nse_cash"
      ? "EQUITY"
      : moment(item.expiry_date).format("DD-MMM");

  /** 🔹 Rate Format Helper */
  const formatRate = (rate) =>
    rate && !isNaN(rate)
      ? item.type === "forex_future"
        ? rate
        : parseFloat(rate).toFixed(2)
      : 0;

  /** 🔹 Edit Handlers (Role Based) */
  const handleOpenEdit = (type) => {
    if (!item) return;
    const editActions = {
      super: () => {
        window.user_id = item.super_id;
        window.openeditSuper?.();
      },
      master: () => {
        window.user_id = item.master_id;
        window.masterModalOpen?.();
      },
      user: () => {
        window.user_id = item.user_id;
        window.userModalOpen?.();
      },
    };
    editActions[type]?.();
  };

  return (
    <li
      key={item.id}
      className={`menuContainer addHight text ${
        id === index ? "selection" : ""
      }`}
    >
      {/* 🔸 Icon */}
      <div className="menuIcon">
        <Icon symbol_id={item.symbol_id} item={item} />
      </div>

      {/* 🔸 Exchange */}
      <div className="menuExchange small">{exchangeName}</div>

      {/* 🔸 User Hierarchy */}
      {userType === 1 && (
        <div onClick={() => handleOpenEdit("super")} className="menuExchange">
          <div className="user_id">{item.super_username}</div>
        </div>
      )}

      {(userType === 1 || userType === 2) && (
        <div onClick={() => handleOpenEdit("master")} className="menuExchange">
          <div className="user_id">{item.master_username}</div>
        </div>
      )}

      {(userType === 1 || userType === 2 || userType === 3 || userType === 5) && (
        <div onClick={() => handleOpenEdit("user")} className="menuExchange">
          <div className="user_id">{item.username}</div>
        </div>
      )}

      {/* 🔸 Symbol / Expiry */}
      <div className={`menuSymbol ${item.type === "fo" ? "small" : ""}`}>
        {item.symbol}
      </div>
      <div className="menuExpiry">{expiryLabel}</div>

      {/* 🔸 Buy / Sell / Qty / Rate */}
      <div className="menuBuyPrice">
        <div
          className={`menuBuyPrice ${
            item.buy_sell === 0 ? "buytext" : "selltext"
          }`}
        >
          {item.buy_sell === 0 ? "BUY" : "SELL"}
        </div>
      </div>

      <div className="menuBuyPrice">{item.qty}</div>
      <div className="menuBuyPrice">{formatRate(item.rate)}</div>

      {/* 🔸 Live Rate */}
      <div className="menuBuyPrice">
        <LiveRate symbol_id={item.symbol_id} buy_sell={item.buy_sell} />
      </div>

      {/* 🔸 Profit / Loss */}
      <ProfitLoss
        symbol_id={item.symbol_id}
        item={item}
        total={total}
        userType={userType}
      />

      {/* 🔸 Time Tick */}
      <div className="menuLtt small">
        <TimeTick symbol_id={item.symbol_id} />
      </div>

      {(userType === 3 || userType === 4) && (
        <div className="menuLtt flex flex-col items-center justify-center">
          <div className="extraSmall">
            {moment(item.date_created).format("DD-MM-YYYY")}
          </div>
          <div className="small">
            {moment(item.date_created).format("HH:mm:ss")}
          </div>
        </div>
      )}
      {(userType === 3 || userType === 4) && (
        <div className="menuLtt flex flex-col items-center justify-center">
          <div className="extraSmall">
            {moment(item.date_update).format("DD-MM-YYYY")}
          </div>
          <div className="small">
            {moment(item.date_update).format("HH:mm:ss")}
          </div>
        </div>
      )}

      {/* 🔸 Trade Button */}
      <div onClick={() => setShow(true)} className="menuBuyPrice">
        <button
          className={`${"bg-[var(--primary)] text-[var(--white)]"} mr-1 px-2.5 py-1 text-[12px] relative flex items-center justify-center gap-1 font-semibold uppercase rounded-md transition-all duration-300 cursor-pointer border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.1)]`}
        >
          TRADE
        </button>
      </div>

      {/* 🔸 Trade Modal */}
      <Dialog
        visible={show}
        closeOnEscape
        closeIcon
        onHide={() => setShow(false)}
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
      >
        <Trade item={item} close={() => setShow(false)} />
      </Dialog>
    </li>
  );
}
